module.exports = __webpack_public_path__ + "img/Slice4-min.2732da7f.png";